/**
 * data-registry.ts — Singleton registry for the IDataService.
 *
 * See ADR 0004 for rationale. The data service is a per-app singleton:
 * read-only, stateless, initialized once in main.ts before the AppShell boots.
 * Views and panels access it via getDataService() in their onInit().
 *
 * Calling getDataService() before setDataService() throws, catching the
 * "forgot to wire the service" bug at the earliest possible point.
 */

import type { IDataService } from './IDataService';

let instance: IDataService | null = null;

export function setDataService(service: IDataService): void {
  instance = service;
}

export function getDataService(): IDataService {
  if (!instance) {
    throw new Error(
      '[data-registry] getDataService() called before setDataService(). ' +
        'Ensure main.ts calls setDataService(service) after service.init().',
    );
  }
  return instance;
}
